import React from "react";
import { Helmet } from "react-helmet-async";
import { useLocation } from "react-router-dom";

// Define meta data for each route
export const metaData = {
  "/": {
    title: "Best Study Abroad Consultants in Bangalore | Nova EduBridge",
    description: "Looking for the best study abroad consultants in Bangalore? Get expert guidance for university admissions, applications, student visas and overseas education.",
    keywords: "abroad education consultants, study abroad programs, study abroad consultancy in Bangalore, global education consultants in Bangalore, overseas study consultants, abroad education consultants in Bangalore",
    h1: "Best Study Abroad Consultants in Bangalore",
  },

  "/services": {
    title: "Study Abroad Consultant Services in Bangalore | Nova EduBridge",
    description: "Explore study abroad consultant services in Bangalore, including university selection, admissions, visa counselling, test preparation and overseas education support.",
    keywords: "abroad education consultants, study abroad services, overseas education consultants, foreign education consultants",
    h1: "Study Abroad Consultant Services in Bangalore",
  },

  "/about": {
    title: "Study Abroad Consultants in Bangalore | About Nova EduBridge",
    description: "Learn about Nova EduBridge, trusted study abroad consultants in Bangalore providing expert guidance for university selection, admissions, visas and overseas education.",
    keywords: "education consultancy, study abroad scholarships, study overseas scholarships, best country for abroad study, best countries to study abroad",
    h1: "Study Abroad Consultants in Bangalore",
  },

  "/services/university-country-course-selection": {
    title: "Abroad Education Guidance | University & Course Selection",
    description: "Get expert abroad education guidance to choose the right country, university and course based on your academic profile, career goals and study preferences.",
    keywords: "overseas admission consultants, best study abroad consultants, university admission support abroad, study abroad counselling services",
    h1: "Abroad Education Guidance for Students",
  },

  "/services/application-and-admission-assistance": {
    title: "Study Abroad Application & Admission Assistance | Nova EduBridge",
    description: "Get expert study abroad application and admission assistance for international universities, including application guidance, documentation and admission support.",
    keywords: "university admission guidance, international university admissions, foreign university application process, admission assistance services for students",
    h1: "Study Abroad Application and Admission Assistance",
  },

  "/careers": {
    title: "Study Abroad Consultancy Careers | Careers at Nova EduBridge",
    description: "Explore career opportunities at Nova EduBridge and build your career in overseas education, international admissions and study abroad consultancy.",
    keywords: "education consultancy careers, overseas education consultant hiring, overseas education careers, international education careers, education industry careers",
    h1: "Study Abroad Consultancy Careers",
  },

  "/Contact": {
    title: "Contact Study Abroad Consultants in Bangalore | Nova EduBridge",
    description: "Contact Nova EduBridge for expert guidance on study abroad programs, university admissions, applications, courses and student visa assistance in Bangalore.",
    keywords: "study abroad consultants Bangalore, study abroad consultancy Bangalore, overseas education consultants Bangalore, study abroad counselling Bangalore",
    h1: "Contact Study Abroad Consultants in Bangalore",
  },

  "/services/application-submission": {
    title: "Study Abroad Application Assistance | Nova EduBridge",
    description: "Get expert assistance with study abroad applications, documentation and university submissions to make your overseas education application process easier.",
    keywords: "study abroad application, abroad scholarships application, foreign scholarships, study abroad scholarship application, UK study abroad scholarships",
    h1: "Study Abroad Application Assistance",
  },

  "/services/visa-counseling": {
    title: "Student Visa Counselling in Bangalore | Nova EduBridge",
    description: "Get expert student visa counselling in Bangalore for visa applications, documentation, requirements and guidance for studying abroad.",
    keywords: "visa counselling, student visa consultant, visa consultant, visa expert, student visa counselling",
    h1: "Student Visa Counselling",
  },

  "/destinations/Asia": {
    title: "Study Abroad in Asia | Universities & Student Visa Guidance",
    description: "Explore study abroad opportunities in Asia with guidance on universities, courses, student visa requirements, applications and overseas education support.",
    keywords: "study abroad in Asia, study in Asia, Asian universities for international students, student visa counselling for Asia, study abroad consultants for Asia",
    h1: "Study Abroad in Asia",
  },

  "/destinations/China": {
    title: "Study in China for International Students | Nova EduBridge",
    description: "Explore study in China with guidance on universities, top courses, scholarships, student visa requirements and affordable international education opportunities.",
    keywords: "study in China, universities in China for international students, China student visa requirements, study abroad in China, top courses in China",
    h1: "Study in China for International Students",
  },

  "/destinations/South Korea": {
    title: "Study in South Korea for International Students | Nova EduBridge",
    description: "Explore study in South Korea with guidance on universities, top courses, scholarships, student visa requirements and global career opportunities.",
    keywords: "study in South Korea, universities in South Korea for international students, South Korea student visa requirements, study abroad in South Korea, top courses in South Korea",
    h1: "Study in South Korea for International Students",
  },

  "/destinations/Japan": {
    title: "Study in Japan for International Students | Nova EduBridge",
    description: "Explore study in Japan with guidance on universities, top courses, scholarships, student visa requirements and international education opportunities.",
    keywords: "study in Japan, universities in Japan for international students, Japan student visa requirements, study abroad in Japan, top courses in Japan",
    h1: "Study in Japan for International Students",
  },

  "/services/pre-departure-briefing": {
    title: "Pre-Departure Briefing for Students | Nova EduBridge",
    description: "Prepare for your overseas journey with pre-departure guidance covering travel, accommodation, documents, safety and essential study abroad tips.",
    keywords: "pre-departure tips for international students, pre-departure session for abroad studies, pre-departure guidance for USA UK Canada students, pre-departure support for overseas education",
    h1: "Pre-Departure Briefing for Students",
  },

  "/services/post-arrival-assistance-and-services": {
    title: "Post-Arrival Assistance for International Students | Nova EduBridge",
    description: "Get reliable post-arrival assistance for international students, including accommodation guidance, local support and essential overseas education services.",
    keywords: "overseas education support services, study abroad loan assistance, study abroad consultancy services, overseas education support in the UK",
    h1: "Post-Arrival Assistance for International Students",
  },

  "/services/assistance-in-accommodation": {
    title: "Student Accommodation Assistance Abroad | Nova EduBridge",
    description: "Get assistance finding safe and affordable accommodation abroad, including dormitories, shared apartments and private housing for international students.",
    keywords: "student accommodation abroad, study abroad housing assistance, international student accommodation, overseas student housing",
    h1: "Accommodation Assistance for Students Abroad",
  },

  "/services/flight-ticket-booking-forex-and-insurance": {
    title: "Forex Services for Study Abroad Students | Nova EduBridge",
    description: "Get forex services for study abroad students along with flight ticket booking and travel insurance support for a smooth international education journey.",
    keywords: "flight ticket booking for international students, student travel insurance, study travel insurance, overseas student insurance, forex for international students",
    h1: "Forex Services for Study Abroad Students",
  },

  "/destinations/Netherlands": {
    title: "Study in the Netherlands for Indian Students | Nova EduBridge",
    description: "Explore study in the Netherlands for Indian students with guidance on universities, courses, student visa requirements, admissions and education opportunities.",
    keywords: "Netherlands student visa requirements, masters in Netherlands for Indian students, study visa Netherlands, Netherlands study visa requirements, Netherlands universities for Indian students",
    h1: "Study in the Netherlands for Indian Students",
  },

  "/services/education-loan-assistance": {
    title: "Education Loan for Study Abroad | Overseas Education Loan",
    description: "Get guidance on education loans for study abroad, including student loans, overseas education financing and financial support for international studies.",
    keywords: "study loan for abroad, student loan for study abroad, overseas education loan, education loan for foreign studies, student loan for studying abroad",
    h1: "Education Loan for Study Abroad",
  },

  "/courses": {
    title: "Best Courses to Study Abroad | Courses & Programs | Nova EduBridge",
    description: "Explore the best courses to study abroad and get guidance on IELTS, TOEFL, PTE, English test requirements and international education programs.",
    keywords: "English tests for study abroad, PTE exam for international students, study abroad English test eligibility, IELTS TOEFL PTE for overseas education, visa English test requirements",
    h1: "Best Courses to Study Abroad",
  },

  "/privacy-policy": {
    title: "Privacy Policy for Education Consultancy | Nova EduBridge",
    description: "Read the Nova EduBridge privacy policy to understand how we collect, use, protect and manage personal information and student data on our website.",
    keywords: "privacy policy, online privacy policy, student data privacy policy, personal information privacy policy",
    h1: "Privacy Policy for Education Consultancy",
  },

  "/terms-and-conditions": {
    title: "Terms and Conditions for Education Consultancy | Nova EduBridge",
    description: "Read the terms and conditions governing the use of the Nova EduBridge website, services, content and overseas education consultancy information.",
    keywords: "website terms and conditions, terms of service, user terms and policy",
    h1: "Terms and Conditions for Education Consultancy",
  },

  "/destinations/USA": {
    title: "Study Abroad Programs in USA | Universities & Visa Guidance",
    description: "Explore study abroad programs in USA with guidance on universities, courses, scholarships, admissions and student visa requirements for international students.",
    keywords: "foreign study consultancy in USA, scholarships abroad in USA, study in USA, scholarships for students in USA",
    h1: "Study Abroad Programs in USA",
  },

  "/destinations/UK": {
    title: "Study in UK for Indian Students | Universities & Visa Guidance",
    description: "Discover how to study in the UK for Indian students with guidance on universities, courses, scholarships, admissions and student visa requirements.",
    keywords: "scholarships for Indian students in UK, abroad education consultants Bangalore, overseas scholarships, study in UK for Indian students",
    h1: "Study in UK for Indian Students",
  },

  "/destinations/Australia": {
    title: "Study in Australia for International Students | Nova EduBridge",
    description: "Explore how to study in Australia with guidance on top universities, courses, MBA programs, admissions, scholarships and student visa requirements.",
    keywords: "best colleges in Australia, courses in Australia, universities in Australia, MBA in Australia, study in Australia for international students",
    h1: "Study in Australia",
  },

  "/destinations/Canada": {
    title: "Study Abroad in Canada | Universities, Courses & Visa Guidance",
    description: "Plan to study abroad in Canada with expert guidance on universities, courses, scholarships, admissions and student visa requirements for international students.",
    keywords: "career abroad in Canada, best countries to study abroad, student visa consultant for Canada, scholarships in Canada, study in Canada for Indian students",
    h1: "Study Abroad in Canada",
  },

  "/destinations/NewZealand": {
    title: "Study in New Zealand for International Students | Nova EduBridge",
    description: "Explore study in New Zealand with guidance on universities, top courses, student visa requirements, costs and overseas education opportunities.",
    keywords: "study abroad in New Zealand, universities in New Zealand for international students, New Zealand student visa guidance, top courses in New Zealand universities, cost of studying in New Zealand",
    h1: "Study in New Zealand",
  },

  "/destinations/Ireland": {
    title: "Study in Ireland for International Students | Nova EduBridge",
    description: "Explore study in Ireland with guidance on universities, top courses, scholarships, student visa requirements and post-study work opportunities.",
    keywords: "Ireland student visa requirements, universities in Ireland for international students, scholarships for Indian students in Ireland, post-study work opportunities in Ireland, top courses in Ireland universities",
    h1: "Study in Ireland",
  },

  "/destinations/Germany": {
    title: "Study in Germany for International Students | Nova EduBridge",
    description: "Explore study in Germany with guidance on universities, top courses, student visa requirements, tuition costs and opportunities for international students.",
    keywords: "study abroad in Germany, universities in Germany for international students, Germany student visa requirements, top courses in German universities, cost of studying in Germany",
    h1: "Study in Germany",
  },

  "/destinations/France": {
    title: "Study in France for International Students | Nova EduBridge",
    description: "Explore study in France with guidance on universities, courses, student visa requirements, costs and study abroad opportunities for international students.",
    keywords: "study abroad in France, universities in France for international students, France student visa requirements, top courses in French universities, cost of studying in France",
    h1: "Study in France",
  },

  "/destinations/Europe": {
    title: "Study in Europe for International Students | Nova EduBridge",
    description: "Explore study in Europe with guidance on top universities, courses, student visa requirements, costs and international education opportunities.",
    keywords: "study abroad in Europe, top European universities for international students, Europe student visa guidance, best courses in Europe for international students, cost of studying in Europe",
    h1: "Study in Europe",
  },

  "/destinations/Dubai": {
    title: "Study in Dubai for International Students | Nova EduBridge",
    description: "Explore study in Dubai with guidance on universities, top courses, student visa requirements, costs and international education opportunities.",
    keywords: "study abroad in Dubai, universities in Dubai for international students, Dubai student visa requirements, top courses in Dubai universities, cost of studying in Dubai",
    h1: "Study in Dubai",
  },

  "/destinations/Singapore": {
    title: "Study in Singapore for International Students | Nova EduBridge",
    description: "Explore study in Singapore with guidance on universities, top courses, student visa requirements, tuition costs and international education opportunities.",
    keywords: "study abroad in Singapore, universities in Singapore for international students, Singapore student visa requirements, top courses in Singapore universities, cost of studying in Singapore",
    h1: "Study in Singapore",
  },

  "/destinations/Switzerland": {
    title: "Study in Switzerland for International Students | Nova EduBridge",
    description: "Explore study in Switzerland with guidance on universities, top courses, student visa requirements, costs and overseas education opportunities.",
    keywords: "study abroad in Switzerland, universities in Switzerland for international students, Switzerland student visa requirements, top courses in Swiss universities, cost of studying in Switzerland",
    h1: "Study in Switzerland",
  },

  "/destinations/Afghanistan": {
    title: "Study in Afghanistan for International Students | Nova EduBridge",
    description: "Explore study in Afghanistan with guidance on universities, courses, student visa requirements, education costs and opportunities for international students.",
    keywords: "study abroad in Afghanistan, universities in Afghanistan for international students, Afghanistan student visa requirements, top courses in Afghanistan universities, cost of studying in Afghanistan",
    h1: "Study in Afghanistan",
  },

  "/destinations/Uzbekistan": {
    title: "Study in Uzbekistan for International Students | Nova EduBridge",
    description: "Explore study in Uzbekistan with guidance on universities, top courses, student visa requirements, costs and education opportunities for international students.",
    keywords: "study abroad in Uzbekistan, universities in Uzbekistan for international students, Uzbekistan student visa requirements, top courses in Uzbekistan universities, cost of studying in Uzbekistan",
    h1: "Study in Uzbekistan",
  },

  "/destinations/Kazakhstan": {
    title: "Study in Kazakhstan for International Students | Nova EduBridge",
    description: "Explore study in Kazakhstan with guidance on universities, courses, student visa requirements, education costs and opportunities for international students.",
    keywords: "study abroad in Kazakhstan, universities in Kazakhstan for international students, Kazakhstan student visa requirements, top courses in Kazakhstan universities, cost of studying in Kazakhstan",
    h1: "Study in Kazakhstan",
  },

  "/destinations/Kyrgyzstan": {
    title: "Study in Kyrgyzstan for International Students | Nova EduBridge",
    description: "Explore study in Kyrgyzstan with guidance on universities, MBBS courses, student visa requirements, affordable education and opportunities for international students.",
    keywords: "top universities in Kyrgyzstan for international students, study MBBS in Kyrgyzstan for Indian students, affordable education in Kyrgyzstan for foreigners, Kyrgyzstan student visa process and requirements, best courses to study in Kyrgyzstan",
    h1: "Study in Kyrgyzstan",
  },

  "/destinations/Russia": {
    title: "Russian Universities for International Students | Nova EduBridge",
    description: "Explore Russian universities for international students with guidance on MBBS, top courses, student visa requirements, costs and admission opportunities.",
    keywords: "top universities in Russia for international students, study MBBS in Russia for Indian students, affordable education in Russia for international students, Russia student visa process and requirements, best courses to study in Russia",
    h1: "Russian Universities for International Students",
  },

  "/destinations/Georgia": {
    title: "Study in Georgia for International Students | Nova EduBridge",
    description: "Explore study in Georgia with guidance on universities, top courses, student visa requirements, costs and overseas education opportunities.",
    keywords: "study abroad in Georgia for international students, universities in Georgia for international students, Georgia student visa requirements and process, top courses in Georgian universities, cost of studying in Georgia",
    h1: "Study in Georgia",
  },

  "/destinations/Poland": {
    title: "Universities in Poland for International Students | Nova EduBridge",
    description: "Explore universities in Poland for international students, including top courses, MBBS options, visa requirements, affordable education and admission guidance.",
    keywords: "top courses in Polish universities, study MBBS in Poland for international students, Poland student visa requirements and process, affordable education in Poland for international students, benefits of studying in Poland",
    h1: "Universities in Poland for International Students",
  },

  "/destinations/Italy": {
    title: "Study in Italy for International Students | Nova EduBridge",
    description: "Explore study in Italy with guidance on universities, top courses, student visa requirements, costs and overseas education opportunities.",
    keywords: "study abroad in Italy for international students, universities in Italy for international students, Italy student visa requirements and process, top courses to study in Italy, cost of studying in Italy",
    h1: "Study in Italy",
  },

  "/services/career-counselling-and-profile-evaluation": {
    title: "Career Counselling & Profile Evaluation | Nova EduBridge",
    description: "Get career counselling and profile evaluation to identify suitable courses, universities and study abroad opportunities based on your academic profile and career goals.",
    keywords: "career counselling services for students, profile evaluation for study abroad applications, online career guidance and counselling, personalised career assessment and planning, career path evaluation and mentoring",
    h1: "Career Counselling and Profile Evaluation",
  },

  "/services/test-preparation": {
    title: "Test Preparation Services for Study Abroad | Nova EduBridge",
    description: "Prepare for international exams with test preparation services, mock tests, practice exams and coaching for study abroad requirements.",
    keywords: "exam preparation courses online, mock test series and practice exams, standardized test prep programs, online test preparation classes, test coaching and assessment services",
    h1: "Test Preparation Services",
  },
};

const fallbackMetaData = {
    title: "Study Abroad After 12th With Nova EduBridge | Nova EduBridge",
    description: "Plan your future with Nova EduBridge to study abroad after 12th. Get Expert Guidance, top courses, scholarships and global universities with Nova EduBridge.",
    keywords: "study in a different country, how to study abroad, study abroad scholarships, study abroad, study abroad consultants, life in abroad, abroad",
};

const canonicalBaseUrl = "https://novaedubridge.com";

export const getCanonicalUrl = (pathname) => {
  const normalizedPath = pathname.replace(/\/+$/, "") || "/";
  return new URL(normalizedPath, canonicalBaseUrl).toString();
};

export const getPageMeta = (pathname) => {
  const normalizedPath = decodeURIComponent(pathname).replace(/\/+$/, "") || "/";
  return metaData[normalizedPath] || fallbackMetaData;
};

const MetaTags = () => {
  const location = useLocation();
  const pageMeta = getPageMeta(location.pathname);

  return (
    <Helmet>
      <title>{pageMeta.title}</title>
      <meta name="description" content={pageMeta.description} />
      <meta name="keywords" content={pageMeta.keywords} />
      <link rel="canonical" href={getCanonicalUrl(location.pathname)} />
    </Helmet>
  );
};

export default MetaTags;
